var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9226 30.9857V30.9844H31.9304V19.6203C31.9304 14.0609 30.7335 9.77832 24.2342 9.77832C21.1097 9.77832 19.013 11.4929 18.157 13.1184H18.0667V10.2973H11.9043V30.9844H18.321V20.7409C18.321 18.0439 18.8323 15.4359 22.1723 15.4359C25.4633 15.4359 25.5124 18.5138 25.5124 20.9139V30.9857H31.9226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45703 10.2991H7.88149V30.9862H1.45703V10.2991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66525 0C2.61113 0 0.944336 1.66679 0.944336 3.72092C0.944336 5.77504 2.61113 7.47669 4.66525 7.47669C6.71937 7.47669 8.38617 5.77504 8.38617 3.72092C8.38488 1.66679 6.71808 0 4.66525 0V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.9861,
    height: 30.9861,
    fill: "white",
    transform: "translate(0.944336)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo3.8f7bbe81e1d4622e6939ec6a05eef1a0.svg";
export { ForwardRef as ReactComponent };